<template>
  <div>
    <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

    <b-table :busy="isBusy" :fields="fields" :items="filteredItems" sticky-header responsive no-border-collapse
      select-mode="single" selectable show-empty>

      <template #empty>
        <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
          No hay notificaciones que coincidan con los criterios de búsqueda
        </b-card>
        <b-card v-else class="text-center my-2 fs-5">
          Aún no se ha enviado ninguna notificación
        </b-card>
      </template>

      <!--icono de carque de tabla-->
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Cargando datos de tabla...</strong>
        </div>
      </template>

    </b-table>
  </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums/index.js'
import { formatDateTime } from '@/plugins/complianceScripts';

export default {
  name: 'KarinNotificationTable',

  components: {
    AlertDismiss
  },

  data() {
    return {
      isBusy: false,
      items: [],
      selected: [],

      //datos de filtro aqui
      searchQuery: '',

      fields: [
        {
          key: 'sent',
          label: 'Enviado',
          formatter: (value) => {
            return value ? 'Si' : 'No'
          }
        },
        { key: 'description', label: 'Descripción' },

        {
          key: 'creationDate',
          label: 'Fecha de envío',
          formatter: formatDateTime
        },

        {key: 'reviewer', label: 'Revisado por'}
      ]
    }
  },

  async mounted() {
    this.$eventBus.$on(EventNames.FilterKarinNotificationAfterSearch, (query) => {
      this.processingTable();

      this.searchQuery = query

      this.processingTable();
    });

    this.$eventBus.$on(EventNames.PaginationFilterKarinNotification, async (query) => {
      this.processingTable();

      let page = query.page - 1; //se resta 1 por que el indice comienza en 0
      let pageSize = query.pageSize;

      await this.getAllNotification(page, pageSize);

      this.processingTable();
    });
  },

  computed: {
    filteredItems() {
      let filtered = this.items;

      // Filtrar por búsqueda por nombre, apellido, etc.
      if (this.searchQuery) {
        filtered = this.filterForSearch(filtered, this.searchQuery)
      }

      return filtered;
    }
  },

  methods: {
    ...mapActions(["allKarinNotification"]),

    async getAllNotification(page, pageSize) {
      this.items = []

      let result = await this.allKarinNotification({
        page: page,
        pageSize: pageSize
      });

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        return;
      }

      let notifications = result.data.map(x => {
        return {
          ...x,
          reviewer: x.reviewer.mail,
        }
      })

      this.items = notifications
    },

    processingTable() {
      this.isBusy = !this.isBusy
    },

    filterForSearch(karinNotifications, searchQuery) {
      const normalizedQuery = searchQuery.toLowerCase().trim();

      return karinNotifications.filter(item =>
        Object.values(item).some(value =>
          value.toString().toLowerCase().includes(normalizedQuery)
        )
      );
    },
  }
}
</script>
<style></style>
